export default "__VITE_ASSET__DtoLLepl__"